import earcutModule from 'earcut';
export { default as EventEmitter } from 'eventemitter3';
"use strict";
const earcut = earcutModule.default || earcutModule;
export { earcut };
